const PERMISSION_KEY= "notification:sm_subscribe_tracking";
const PAGE_URL = {
    SM_SUBSCRIBE_TRACKING_PAGE: "/admin/notification/sm-subscribe-tracking"
}

export {PERMISSION_KEY, PAGE_URL}

